<template>
  <div style="width: 1200px; margin: 0 auto">


    <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px;position: relative;right:150px">

    <el-breadcrumb-item :to="{ path: '/' }"> <i class="el-icon-location" style="padding-right: 5px" ></i>首页</el-breadcrumb-item>
    <el-breadcrumb-item>{{ moduleName }}</el-breadcrumb-item>

  </el-breadcrumb>
    <el-table @row-click="rowClick" style="margin-bottom: 20px" :show-header="false" :data="noticeList" :row-style="{height:'100px',cursor:'pointer'}">
      <el-table-column >
        <template slot-scope="scope">
          <p style="font-size: 16px;color: black">{{ scope.row.title }}</p>
          <div>
            <el-tag>{{scope.row.moduleName}}</el-tag>
            {{ scope.row.createTime }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="4" :offset="9">
        <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
                    @pagination="getList"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {getMessageList,moduleName} from '../api/index'

export default {
  name: 'notice',

  data() {
    return {
      noticeList: [],
      moduleName:null,
      id:null,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,

      },
    }
  },
  created() {
    this.getList()
    this.getModule()
  },
  watch:{
   $route(){
     this.id=this.$route.params.id
     moduleName(this.id).then(res=>{
       this.moduleName=res.data.data.moduleName
     })
   },
    id(){
     this.getList();
    },
  },
  methods: {
    getModule(){
      moduleName(this.id).then(res=>{
        this.moduleName=res.data.data.moduleName
      })
    },
    rowClick(row ){
      // this.$router.push(`/showArt/${row.id}`)
      window.open(`/showArt/${row.id}`,'_blank')
    },
    getList(){
     this.id=this.$route.params.id;
      getMessageList(this.id,this.queryParams).then(res => {
        this.noticeList = res.data.data.rows
        this.total=res.data.data.total;
        //发布时间去掉时分秒
        for (const dataKey in res.data.data.rows) {
          this.noticeList[dataKey].createTime = res.data.data.rows[dataKey].createTime.split(' ')[0]
        }
      })
    },
  }
}
</script>

<style scoped>
::v-deep.el-table .cell {
  margin-left: 50px !important;
}
</style>
